import $fn from '@/utils/fn.ts';
import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 游戏充值档位
interface PayGradeData {
    token: string,
    game_id: string
}
export const PayGrade = (json: PayGradeData): any => http.httpPost({
    url: httpApi.roleInfo.PayGrade,
    json
})

// 支付宝充值盒子
interface QrAlipayBoxData {
    pay_amount: any,
    uid: string,
    extend: string
}
export const QrAlipayBox = (json: QrAlipayBoxData): any => http.httpPost({
    url: httpApi.Pay.QrAlipayBox,
    json
})

export const QrWechatBox = (json: QrAlipayBoxData): any => http.httpPost({
    url: httpApi.Pay.QrWechatBox,
    json
})

// 充值账号校验
interface CheckUserData {
    token: string,
    account: string
}
export const CheckUser = (json: CheckUserData): any => http.httpPost({
    url: httpApi.roleInfo.CheckUser,
    json
})

// 游戏选择
interface UserGamesData {
    token: string,
    uid: string
}
export const UserGames = (json: UserGamesData): any => http.httpPost({
    url: httpApi.roleInfo.UserGames,
    json
})

// 玩家区服
interface ServerListData {
    game_id: string,
    token: string,
    uid: string
}
export const ServerList = (json: ServerListData): any => http.httpPost({
    url: httpApi.roleInfo.ServerList,
    json
})

// 选择角色
interface RoleListData {
    token: string,
    game_id: string,
    server_id: string
}
export const RoleList = (json: RoleListData): any => http.httpPost({
    url: httpApi.roleInfo.RoleList,
    json
})

// 直充游戏支付宝扫码
interface QrAlipayGameData {
    uid: string,
    box_game_id: string,
    serverid: string,
    roleid: string,
    pay_amount: number,
    extend: string
}
// 直充游戏支付宝扫码
export const QrAlipayGame = (json: QrAlipayGameData): any => http.httpPost({
    url: httpApi.Pay.QrAlipayGame,
    json
})

// 直充游戏微信扫码
export const QrWechatGame = (json: QrAlipayGameData): any => http.httpPost({
    url: httpApi.Pay.QrWechatGame,
    json
})

// 盒子充值档位
interface BoxPayGradeData {
    token: string
}
export const BoxPayGrade = (json: BoxPayGradeData): any => http.httpPost({
    url: httpApi.roleInfo.BoxPayGrade,
    json
})

// 用户钱包余额明细
interface UserWalletDetailedData {
    token: string,
    type: string,
    stime: string,
    etime: string,
    // detail_type: number
}
export const UserWalletDetailed = (json: UserWalletDetailedData): any => http.httpPost({
    url: httpApi.Pay.UserWalletDetailed,
    json
})
// 用户钱包金币明细
export const UserGoldDetailed = (json: UserWalletDetailedData): any => http.httpPost({
    url: httpApi.Pay.UserGoldDetailed,
    json
})

// 充值状态校验
interface PayStatusData {
    token: string,
    pay_order: string
}
export const PayStatus = (json: PayStatusData): any => http.httpPost({
    url: httpApi.Pay.PayStatusUrl,
    json
})

// 游戏币种
interface GetPayInfoJson {
    token: string,
    game_id: string
}
export const getPayInfo = (json: GetPayInfoJson): any => http.httpPost({
    url: httpApi.roleInfo.getPayInfo,
    json
})

// 充值游戏-pc余额/金币支付
interface BalancePayData {
    uid: string,
    box_game_id: string,
    serverid: string,
    roleid: string,
    role_name: string,
    server_name: string
    pay_amount: number,
    props_name: string,
    pay_way: string,
    balance_id: string
}
// 直充游戏支付宝扫码
export const BalancePay = (json: BalancePayData): any => http.httpPost({
    url: httpApi.Pay.BalancePay,
    json
})

// 余额类型
interface ScreenFactorJson {
    token: string
}
export const screenFactor = (json: ScreenFactorJson): any => http.httpPost({
    url: httpApi.Pay.screenFactor,
    json
})

// 交易类型
export const pcScreenFactor = (json: ScreenFactorJson): any => http.httpPost({
    url: httpApi.Pay.pcScreenFactor,
    json
})
